export const login = {
  headline: "Se connecter",
  info: 'Ces données de connexion ne sont pas valables pour la boutique en ligne Maagtechnic. Veuillez en créer de nouvelles sur notre page « portail de commande 3D » pour y avoir accès.',
  inputLabels: {
    userNameOrEmail: "Nom d'utilisateur ou e-mail",
    password: "Mot de passe",
    oldPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    repeatPassword: "Répéter le mot de passe",
  },
  mainActions: {
    login: "Se connecter",
    register: "S'enregistrer",
    forgotPassword: "Mot de passe oublié",
    resetPassword: "Réinitialiser le mot de passe",
  },
  messages: {
    loginFailed: `Le nom d'utilisateur et le mot de passe ne se correspondent pas.`,
    membersOnly: "(membres uniquement)",
    passwordResetSuccess: {
      header: "Mot de passe réinitialisé",
      body: `Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.`,
    },
  },
};
